(() => {
  const owner = document.currentScript;
  const allLabel = owner?.dataset.viewAll || '';
  const addLabel = owner?.dataset.addLabel || '';
  const preserveContext = (params) => {
    const current = new URL(location.href).searchParams;
    const display = current.get('display');
    if (['24', '48', 'all'].includes(display)) params.set('display', display);
    for (const key of ['preview_theme_id', '_fd', 'pb']) {
      const value = current.get(key);
      if (value !== null) params.set(key, value);
    }
    params.delete('page');
  };
  function setupFilters(root) {
    root.querySelectorAll('[data-dulin-filter-form]').forEach(form => {
      if (form.dataset.auditReady) return;
      form.dataset.auditReady = 'true';
      form.addEventListener('formdata', event => {
        preserveContext(event.formData);
        form.querySelectorAll('input[type="number"]').forEach(input => {
          if (!input.value.trim()) event.formData.delete(input.name);
        });
      });
      form.querySelectorAll('.dn-filter-price').forEach(range => {
        const low = range.querySelector('[data-filter-min]');
        const high = range.querySelector('[data-filter-max]');
        if (!low || !high) return;
        const ceiling = low.max;
        const sync = () => {
          low.max = high.value || ceiling;
          high.min = low.value || '0';
        };
        low.addEventListener('input', sync);
        high.addEventListener('input', sync);
        sync();
      });
    });
    root.querySelectorAll('[data-dulin-filter-link]').forEach(link => {
      if (link.dataset.auditReady) return;
      link.dataset.auditReady = 'true';
      const sync = () => {
        const url = new URL(link.href, location.href);
        preserveContext(url.searchParams);
        link.href = url.href;
      };
      sync();
      link.addEventListener('click', sync);
    });
  }
  function setupSticky(root) {
    root.querySelectorAll('sticky-add-to-cart').forEach(sticky => {
      if (sticky.dataset.auditReady) return;
      sticky.dataset.auditReady = 'true';
      const update = () => {
        const bar = sticky.querySelector('[ref="stickyBar"]');
        const button = sticky.querySelector('[ref="addToCartButton"]');
        if (bar) bar.inert = bar.dataset.stuck !== 'true';
        if (!button) return;
        const label = button.querySelector('.add-to-cart-text__content')?.textContent.trim() || addLabel;
        const title = sticky.querySelector('.sticky-add-to-cart__title')?.textContent.trim();
        if (label) button.setAttribute('aria-label', title ? `${label} — ${title}` : label);
      };
      update();
      const observer = new MutationObserver(update);
      observer.observe(sticky, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['data-stuck', 'disabled']});
    });
  }
  const refreshCookies = () => {
    if (typeof window.privacyBanner?.showPreferences !== 'function') return false;
    document.querySelectorAll('[data-footer-cookies]').forEach(button => { button.hidden = false; });
    return true;
  };
  function setup(root = document) {
    setupFilters(root);
    setupSticky(root);
    if (allLabel) root.querySelectorAll('.dn-nav-submenu > a:first-child').forEach(link => { link.textContent = allLabel; });
    refreshCookies();
  }
  function start() {
    setup();
    document.addEventListener('shopify:section:load', event => setup(event.target));
    document.addEventListener('shopifyCustomerPrivacyApiLoaded', refreshCookies);
    window.addEventListener('load', refreshCookies, {once: true});
    let attempts = 0;
    const retry = setInterval(() => {
      attempts += 1;
      if (refreshCookies() || attempts >= 20) clearInterval(retry);
    }, 500);
    document.addEventListener('click', event => {
      document.querySelectorAll('.dn-mobile-nav[open]').forEach(menu => {
        if (!menu.contains(event.target)) menu.open = false;
      });
    });
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.dn-mobile-nav[open], .dn-filter-group[open]').forEach(menu => {
        const focusInside = menu.contains(document.activeElement);
        menu.open = false;
        if (focusInside) menu.querySelector('summary')?.focus();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
